export const drawerActionTypes = {
  OPEN_DRAWER: 'OPEN_DRAWER',
  CLOSE_DRAWER: 'CLOSE_DRAWER',
  TOGGLE_DRAWER: 'TOGGLE_DRAWER',
  EDIT_QUESTION: 'EDIT_QUESTION',
}
